import { Enum } from 'enumify';

class AutosaveControl extends Enum {}

AutosaveControl.initEnum(['PAUSE', 'RESUME', 'CLEAR']);

export default AutosaveControl;
